import React from 'react';
import Breadcrumb from '../../../components/section/Breadcrumb';
import FooterSection from '../section/FooterSection';
import HeaderSection from '../section/HeaderSection';
import SubscribeSection from '../section/SubscribeSection';
import VendorSection from '../section/VendorSection';

function VendorPage() {
    return (
        <>
            <HeaderSection />
            <Breadcrumb title="Vendor" />
            <VendorSection />
            <SubscribeSection />
            <FooterSection />
        </>
    );
}

export default VendorPage;
